<template>
  <el-skeleton class="data-ingestion-menu-skeleton" :loading="true" animated>
    <template #template>
      <div class="data-ingestion-menu-skeleton__header">
        <el-skeleton-item class="data-ingestion-menu-skeleton__title" />
        <el-skeleton-item class="data-ingestion-menu-skeleton__subtitle" />
        <el-skeleton-item class="data-ingestion-menu-skeleton__subtitle" />
      </div>

      <div class="data-ingestion-menu-skeleton__list">
        <div v-for="index in Array.from({ length: 10 })" :key="index" class="data-ingestion-menu-skeleton__item">
          <el-skeleton-item class="data-ingestion-menu-skeleton__icon" variant="circle" />
          <el-skeleton-item class="data-ingestion-menu-skeleton__date" />
        </div>
      </div>

      <div class="data-ingestion-menu-skeleton__pagination">
        <el-skeleton-item
          v-for="index in Array.from({ length: 6 })"
          :key="index"
          class="data-ingestion-menu-skeleton__pagination-icon"
          variant="circle"
        />
      </div>
    </template>
  </el-skeleton>
</template>

<style lang="scss" scoped>
.data-ingestion-menu-skeleton {
  display: flex;
  flex-direction: column;

  &__header {
    margin-bottom: 36px;
  }

  &__title {
    height: 20px;
    width: 100%;
    display: block;
    margin-bottom: 8px;
    border-radius: 4px;
  }

  &__subtitle {
    height: 12px;
    width: 100%;
    display: block;
    margin-bottom: 4px;
    border-radius: 4px;
  }

  &__list {
    margin-bottom: 28px;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  &__icon {
    height: 12px;
    width: 12px;
    margin-right: 14px;
    border-radius: 8px;
  }

  &__date {
    height: 20px;
    width: 90%;
    display: block;
    border-radius: 8px;
  }

  &__pagination {
    display: flex;
    align-items: center;

    &-icon {
      height: 24px;
      width: 24px;
      margin-right: 8px;
    }
  }
}
</style>
